import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
var _excluded = ["placeholder", "meta", "disabled", "Prefix"];
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source), true)).call(_context2, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context3; _forEachInstanceProperty(_context3 = ownKeys(Object(source))).call(_context3, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useMemo, forwardRef } from 'react';
import Box from '@rexlabs/box';
import { useStyles, StyleSheet, text, StylesProvider } from '@rexlabs/styling';
import { TextInput } from '@rexlabs/text-input';
import Icons from '@rexlabs/icons';
import { useHandleOverflow } from '@rexlabs/react-hooks';
import { Truncate } from '@rexlabs/text';
import { Tooltip } from '@rexlabs/tooltip';
import { useSelect } from '../../hooks/use-select';
var ChevronDown = Icons.ChevronDown;
var defaultStyles = StyleSheet({
  container: {
    minWidth: 0,
    gap: function gap(_ref) {
      var token = _ref.token;
      return token('spacing.xs');
    }
  },
  disabled: {
    color: function color(_ref2) {
      var token = _ref2.token;
      return token('color.textStyle.body.hint');
    }
  },
  item: _objectSpread({
    whiteSpace: 'nowrap'
  }, text.styles({
    target: 'select.toggleButton.item',
    fallback: 'normal.default'
  })),
  fitItem: {
    minWidth: 0
  },
  placeholder: _objectSpread({
    userSelect: 'none'
  }, text.styles({
    target: ['textInput.hintText', 'select.toggleButton.placeholder'],
    fallback: 'normal.default',
    color: function color(_ref3) {
      var token = _ref3.token;
      return token('color.textStyle.body.hint');
    }
  })),
  extraItems: _objectSpread({
    whiteSpace: 'nowrap'
  }, text.styles({
    target: 'select.toggleButton.extraItems',
    fallback: 'normal.default',
    color: function color(_ref4) {
      var token = _ref4.token;
      return token('color.textStyle.body.subtext');
    }
  }))
});

function getTextInputTokens(searchable) {
  return {
    textInput: {
      cursor: searchable ? 'text' : 'pointer'
    }
  };
}
/**
 * This toggle button is what displays the selected values
 * as well as being the interaction point for opening the menu
 * either when this button is focused or clicked
 */


export var SimpleToggleButton = /*#__PURE__*/forwardRef(function SimpleToggleButton(_ref5, ref) {
  var placeholder = _ref5.placeholder,
      meta = _ref5.meta,
      disabled = _ref5.disabled,
      Prefix = _ref5.Prefix,
      props = _objectWithoutProperties(_ref5, _excluded);

  var s = useStyles(defaultStyles);

  var _useSelect = useSelect(),
      multi = _useSelect.multi,
      searchable = _useSelect.searchable,
      selectedItem = _useSelect.selectedItem,
      selectedItems = _useSelect.selectedItems,
      itemToString = _useSelect.itemToString,
      getItemId = _useSelect.getItemId;

  var displayedItems = multi ? selectedItems : selectedItem ? [selectedItem] : [];

  var _useHandleOverflow = useHandleOverflow({
    itemCount: displayedItems.length
  }),
      containerRef = _useHandleOverflow.containerRef,
      itemRefs = _useHandleOverflow.itemRefs,
      extraCountRef = _useHandleOverflow.extraCountRef,
      visibleItemCount = _useHandleOverflow.visibleItemCount,
      extraItemCount = _useHandleOverflow.extraItemCount,
      isOverflowing = _useHandleOverflow.isOverflowing,
      recalculateLayout = _useHandleOverflow.recalculateLayout;

  var overrides = useMemo(function () {
    return getTextInputTokens(searchable);
  }, [searchable]);
  return /*#__PURE__*/React.createElement(StylesProvider, {
    tokens: overrides
  }, /*#__PURE__*/React.createElement(TextInput, {
    disabled: disabled,
    placeholder: placeholder,
    meta: meta,
    containerProps: _objectSpread({
      ref: ref
    }, props),
    Suffix: ChevronDown,
    Prefix: Prefix
  }, function (_ref6) {
    var placeholder = _ref6.placeholder;
    return /*#__PURE__*/React.createElement(Box, _extends({}, s('container', {
      searchable: searchable,
      disabled: disabled
    }), {
      ref: containerRef,
      flex: 1
    }), displayedItems.length > 0 ? _mapInstanceProperty(displayedItems).call(displayedItems, function (item, index) {
      var key = getItemId(item);

      if (!recalculateLayout && index >= visibleItemCount) {
        return null;
      }

      return /*#__PURE__*/React.createElement("span", _extends({}, s('item', {
        fitItem: index === 0 && isOverflowing
      }), {
        key: key,
        ref: function ref(node) {
          if (node) {
            itemRefs.current.set(key, node);
          } else {
            itemRefs.current.delete(key);
          }
        }
      }), /*#__PURE__*/React.createElement(MaybeTruncate, {
        truncate: index === 0 && isOverflowing
      }, itemToString(item) + (index === displayedItems.length - 1 ? '' : ',')));
    }) : /*#__PURE__*/React.createElement(Truncate, s('placeholder'), placeholder), !recalculateLayout && extraItemCount <= 0 ? null : /*#__PURE__*/React.createElement(Tooltip, {
      Content: function Content() {
        var _context;

        return _mapInstanceProperty(_context = _sliceInstanceProperty(displayedItems).call(displayedItems, visibleItemCount)).call(_context, function (item) {
          return itemToString(item);
        }).join(', ');
      }
    }, /*#__PURE__*/React.createElement("span", _extends({}, s('extraItems'), {
      ref: extraCountRef
    }), "+".concat(extraItemCount, " more"))));
  }));
});

function MaybeTruncate(_ref7) {
  var children = _ref7.children,
      truncate = _ref7.truncate;

  if (truncate) {
    return /*#__PURE__*/React.createElement(Truncate, null, children);
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
}